import { Injectable } from "@angular/core";
import { AppVersion } from "@app/core/version/domain/model/app-version";
import { Observable, of } from "rxjs";
import { BUILD, VERSION, DATE } from "src/autogenerated-version";
@Injectable({
  providedIn: "root",
})
export class GetAppVersionDAO {
  get(): Observable<AppVersion> {
    return of({ BUILD, VERSION, DATE });
  }
}
